// Personal libs
import { Repository } from './common/repository.class';
import {
  IApiGetTokensParams,
  apiPostAuth,
  apiPostRefreshTokens
} from '@data/datasource/remote/auth.api';
import { ApiError } from '@shared/error/api.error';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { $t } from '@i18n/utils';
import { timestampToLitteral } from '@shared/lib/date.lib';
import { IAuthRequest } from '@shared/interface/auth-request.interface';
import { IAuthResponse } from '@shared/interface/auth-response.interface';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { apiPostForgottenPass } from '@data/datasource/remote/password.api';

class AuthRepository extends Repository {
  constructor() {
    super();
  }

  /*****************************************
   *
   * POST FUNCTIONS
   *
   *****************************************/
  // Refresh tokens
  refreshTokens(
    params: IApiGetTokensParams,
  ): Promise<IApiResponse<IAuthResponse, string> | undefined> {
    return apiPostRefreshTokens(params)
  }

  forgottenPass(params: IAuthRequest): Promise<void | IApiResponse<string, undefined>> {
    return apiPostForgottenPass(params).catch((error: ErrorConstructor) => {
      if (error instanceof ApiError) {
        if (error.code === 'FORGOT_ERR_RATE_LIMIT') {
          throw new Error(
            $t('generic.rateLimiter', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            })
          );
        }
      } else {
        throw this.manageUnknownError(sessionManager.isOnline.value)
      }
    });
  }

  // Refresh tokens
  auth(
    params: IAuthRequest,
  ): Promise<IApiResponse<IAuthResponse, string> | undefined> {
    return apiPostAuth(params).catch((error: ErrorConstructor) => {
      if (error instanceof ApiError) {
        if (error.code?.startsWith('AUTH_ERR')) {
          throw new Error(
            $t(`signin.login.error.${error.code}`, {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else {
          throw new Error($t('generic.unknownError'));
        }
      } else {
        throw this.manageUnknownError(sessionManager.isOnline.value)
      }
    });
  }
}

export default new AuthRepository();
